import { BaseApiClient } from './BaseAPIClient';
import { AlbumState } from '@/data/models/albumState';
import { IChangeRequest } from '@/data/models/changeRequest';
import { ResponseModel } from '@/data/models/model';
import { ISalesTeam } from '@/data/models/salesTerritory';

export class ChangeRequestApiClient extends BaseApiClient {
  constructor() {
    super(BaseApiClient.findBaseUrl());
  }

  async createChangeRequest(
    id: string
  ): Promise<ResponseModel<IChangeRequest>> {
    const path = `/prs/api/v1/albums/${id}/changeRequests`;
    return await this.post(path, {});
  }

  async getActiveChangeRequest(
    id: string
  ): Promise<ResponseModel<IChangeRequest>> {
    const path = `/prs/api/v1/albums/${id}/changeRequests/active`;
    return await this.get(path);
  }

  async getChangeRequestById(
    id: string,
    crId: string
  ): Promise<ResponseModel<IChangeRequest>> {
    const path = `/prs/api/v1/albums/${id}/changeRequests/${crId}`;
    return await this.get(path);
  }

  async getChangeRequests(
    id: string
  ): Promise<ResponseModel<IChangeRequest[]>> {
    const path = `/prs/api/v1/albums/${id}/changeRequests`;
    return await this.get(path);
  }

  async updateChangeRequest(
    id: string,
    crId: string,
    apiBody: IChangeRequest
  ): Promise<ResponseModel<IChangeRequest>> {
    const path = `/prs/api/v1/albums/${id}/changeRequests/${crId}`;
    const protectedApiBody = {
      ...apiBody,
      changeRequestAlbum: {
        ...apiBody.changeRequestAlbum,
        catalogNumber: apiBody.originalAlbum.catalogNumber,
      },
    };
    return await this.put(path, protectedApiBody);
  }

  async deleteChangeRequest(
    albumId: string,
    changeRequestId: string,
    nonce: string
  ): Promise<any> {
    const path = `/prs/api/v1/albums/${albumId}/changeRequests/${changeRequestId}?nonce=${nonce}`;
    return await this.delete(path);
  }

  async updateChangeRequestState<IAlbum>(
    id: string,
    crId: string,
    state: AlbumState,
    nonce: string
  ): Promise<IAlbum> {
    const path = `/prs/api/v1/albums/${id}/changeRequests/${crId}/state`;
    const apiBody = { transitionState: state, nonce };
    return await this.post<any>(path, apiBody);
  }

  async getAllowedSalesTeams(
    id: string,
    crId: string
  ): Promise<ResponseModel<ISalesTeam[]>> {
    const path = `/prs/api/v1/albums/${id}/changeRequests/${crId}/allowed-sales-teams`;
    return await this.get(path);
  }
}

export const changeRequestApiClient = new ChangeRequestApiClient();
